import React from "react";
import PropTypes from "prop-types";
import "./Banner.style.scss";

class Banner extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return <div className="banner">{this.props.text}</div>;
  }
}

Banner.propTypes = {
  text: PropTypes.string,
};

Banner.defaultProps = {
  text: "Sanctions Explorer is currently under maintenance. We're reviewing and improving the underlying data, so updates are paused for now. As always, we recommend verifying findings against the original source.",
};

export default Banner;
